export const STATUS_MENU_PLACEHOLDER_HEIGHT = 37;
export const STATUS_MENU_PLACEHOLDER_WIDTH = 113;
